import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
// import { PlusIcon } from "../../../../common/imagePath";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
  AWS_IMAGE_FOLDER_CATEGORIES,
  AWS_IMAGE_FOLDER_BRANDS,
} from "../../../../common/Constant";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import Loader from "../../../../components/Loader/Loader";
import { checkUserPermission } from "../../../../common/UserPermission";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import DataTable from "react-data-table-component";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  UploadFile,
} from "@mui/icons-material";
import { MenuItem } from "@mui/material";
// import { Noimage } from "../../../../common/imagePath";
import TableCell from "@material-ui/core/TableCell";
import { Noimage } from "../../../../common/imagePath";
import { uploadAWS } from "../../../../common/AWSHelper";
// import TableRow from '@material-ui/core/TableRow';
// import Button from '@material-ui/core/Button';

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "add-brand";
let PERMISSION_EDIT = "edit-brand";
let PERMISSION_DELETE = "delete-brand";

const Brand = (props) => {
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");

  const [selectedImage, setSelectedImage] = useState("");
  const [previewImage, setPreviewImage] = useState("");

  const [formValues, setFormValues] = useState({
    ID: 0,
    Name: "",
    // Hidefromgrid: false,
    // ParentID: 0,
    Imagename: "",
    brandInfopopup: "",
  });
  // const [selectedParentbrand, setselectedParentbrand] = useState({});
  const [searchtext, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortingId, setSortingId] = useState(4);
  const [sortingDirection, setSortingDirection] = useState("desc");
  // const [selectedData, setSelectedData] = useState([]);

  const [checkedBox, setCheckedBox] = useState([]);

  const [valueAllChecked, setValueAllChecked] = useState();

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [showDateFilterModal, setShowDateFilterModal] = useState(false);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [modal, setModal] = useState(false);

  //table state
  // const [columnFilters, setColumnFilters] = useState([]);
  const [filtertext, setFiltertext] = useState("");
  const [sorting, setSorting] = useState([{ id: "Name", desc: false }]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [brandInfopopup, setbrandInfopopup] = useState("");
  const [showLoaderUploadImage, setShowLoaderUploadImage] = useState(false);
  const [btnLoader, setBtnLoader] = useState({ Imagename: false });
  const [ImageUrl, setImageUrl] = useState("");

  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("Brand name is required"),
  });
  console.log(sorting, "sorting=>");

  let parentbrandoption = [];
  const itemkits = data.map((u, i) => {
    parentbrandoption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  // Get all Brand data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder1,
    pagination,
    currentorder
  ) => {
    setLoading(true);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === currentorder[0]?.id
    // );
    const columnIndex =
      sorting.length > 0 ? (sorting ? sorting[0]?.id : "") : "";

    axios
      .get(
        `${config.brandBaseUrl}/brands?filtertext=${
          filtertext == undefined ? "" : filtertext
        }&currentorder=${
          currentorder?.length > 0
            ? currentorder[0]?.desc === undefined
              ? "desc"
              : currentorder[0]?.desc === true
              ? "desc"
              : "asc"
            : "desc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination?.pageIndex + 1
        }&pagesize=${0}`, //pagination?.pageSize
        {
           headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);
        setLoading(false);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);
        const updatedData = res.data.ResponseData?.filter(
          (el) => el.IsShowEcommerceMenu === 1
        );
        const idArray = updatedData.map((el) => el.ID);
        setCheckedBox(idArray);

        if (res.data.ResponseData?.length === idArray?.length) {
          setValueAllChecked(true);
        } else {
          setValueAllChecked(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
    setLoading(false);
    

  };

  useEffect(() => {
    handleListData(
      1,
      perPage,
      filtertext,
      sortingId,
      sortingDirection,
      pagination,
      sorting
    );
  }, [filtertext, sortingId, sortingDirection, pagination, sorting]);

  const handleUpdate = (pID) => {
    setLoading(true);
    axios
      .get(`${config.brandBaseUrl}/brands/findbyid?id=${pID}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const brandData = res.data.ResponseData[0];
        console.log(brandData, "checkedit=>");

        const data = {
          ID: brandData.ID,
          Name: brandData.Name,
          // Hidefromgrid: brandData.Hidefromgrid === 1 ? true : false,
          // ParentID: brandData.ParentId,
          Imagename: brandData.Imagename,
          brandInfopopup: brandData.brandInfopopup,
        };
        setFormValues(data);
        setLoading(false);
        // setSelectedImage();
        // setPreviewImage(brandData.Imagename)
        // setImageUrl(brandData.Imagename);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // Crete and Update Brand
  // const handleSubmit = async (eventObject) => {
  //   setLoading(true);
  //   axios
  //     .post(
  //       `${config.brandBaseUrl}/brands/upsert`,
  //       {
  //         id: eventObject.ID,
  //         isactive: 1,
  //         name: eventObject.Name,
  //         loginuserid: loginUserId,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         toastSuccess(SUCCESS_MESSAGE);
  //         handleListData();
  //         setLoading(false);
  //         window.location.reload();
  //       } else if (
  //         res.data.ResponseCode === "ERROR" &&
  //         res.data.ResponseID === -1
  //       ) {
  //         toastError(ERROR_EXISTS);

  //         setLoading(false);
  //       } else {
  //         toastError(ERROR_MESSAGE);
  //         setLoading(false);
  //       }
  //     });
  //     setLoading(false);
  // };

  const uploadFile = async (file, type, event) => {
    setShowLoaderUploadImage(true);
    setBtnLoader({ [type]: true });
    await uploadAWS(file, AWS_IMAGE_FOLDER_BRANDS, (data) => {
      if (data) {
        console.log(data, "data=>");
        setImageUrl(data);
        setShowLoaderUploadImage(false);
        handleSubmit(data, event);
      } else {
        console.log(data, "data error=>");
      }
    });
  };

  const validation = (name, value) => {
    console.log(name, value, "value");
    switch (name) {
      case "Imagename":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const handleSubmit2 = async (event) => {
    setLoading(true);
    console.log(selectedImage, "selectedImage");
    if (selectedImage) {
      console.log(validation("imagename", selectedImage), "imageclg");
      if (validation("imagename", selectedImage)) {
        await uploadFile(selectedImage, "Imagename", event);
      } else {
        toastSuccess("image error, jpg|jpeg|png|gif|mp4");
        setLoading(false);
        return;
      }
    } else {
      console.log(event, "event");
      handleSubmit("", event);
    }
  };

  const handleSubmit = async (imageurl, eventObject) => {
    axios
      .post(
        `${config.brandBaseUrl}/brands/upsert`,
        {
          id: eventObject.ID,
          isactive: 1,
          name: eventObject.Name,
          loginuserid: loginUserId,
          Imagename: imageurl,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          handleListData();
          setLoading(false);
          window.location.reload();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);

          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
        setLoading(false);
      });

    // setLoading(false);
    // setPreviewImage("");
    // // setSelectedImage("");
    // setFormValues({
    //   values : ""
    // });
    // window.location.reload();
  };

  // const handleSaveRow = async ({ exitEditingMode, row, values }) => {
  //   setLoading(true);
  //   //if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
  //   data[row.index] = values;
  //   // //send/receive api updates here
  //   setData([...data]);
  //   axios
  //     .post(
  //       `${config.brandBaseUrl}/brands/upsert`,
  //       {
  //         id: row.original.ID,
  //         isactive: 1,
  //         name: values.Name,
  //         loginuserid: loginUserId,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         toastSuccess(SUCCESS_MESSAGE);
  //         // handleListData();
  //         setLoading(false);
  //         // window.location.reload();
  //       } else if (
  //         res.data.ResponseCode === "ERROR" &&
  //         res.data.ResponseID === -1
  //       ) {
  //         toastError(ERROR_EXISTS);

  //         setLoading(false);
  //       } else {
  //         toastError(ERROR_MESSAGE);
  //         setLoading(false);
  //       }
  //     });
  //   exitEditingMode(); //required to exit editing mode
  // };

  // Delete Brand
  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      id: pID,
      loginuserid: loginUserId,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };

  const handleManageDataPopup = () => {
    const clearData = {
      ID: 0,
      Name: "",
      // Hidefromgrid: false,
      // ParentID: 0,
      // Color: "",
      Imagename: "",
      brandInfopopup: "",
    };
    setFormValues(clearData);
    setModal(true);
  };

  const handelShowPopup = (checked) => {
    console.log(checked, "checked");
    setValueAllChecked(checked);
    setShowDateFilterModal(true);
  };

  // useEffect(() => {
  //   let brandsList =
  //   {
  //     brandsList: checkedBox.join(","),
  //     LoginUserId: loginUserId
  //   };

  //   axios
  //     .post(
  //       `${config.brandBaseUrl}/brands/assignbrandecommercemenu`,
  //       brandsList,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         // toastSuccess(SUCCESS_MESSAGE)
  //         console.log("SetDone");
  //       } else if (
  //         res.data.ResponseCode === "ERROR" &&
  //         res.data.ResponseID === -1
  //       ) {
  //         // toastError(ERROR_EXISTS);
  //       } else {
  //         // toastError(ERROR_MESSAGE);
  //       }
  //     });
  // }, [checkedBox]);

  // Table Data
  const commonColumns = [
    {
      name: "Categories",
      selector: "Name",
      width: "50%",
      sortable: true,
    },
    {
      name: "Image",
      selector: "ImageUrl",
      sortable: true,
      cell: (row) => (
        <>
          <Link to={row.Imagename} target="_blank">
            <img
              src={row.Imagename}
              alt="Selected Image"
              style={{
                maxHeight: "50px",
                width: "30px",
                margin: "5px",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Noimage;
              }}
            />
          </Link>
        </>
      ),
    },
    {
      name: (
        <>
          <input
            className="form-check-input mr-1"
            onChange={(event) => handelShowPopup(event.target.checked)}
            type="checkbox"
            role="switch"
            checked={valueAllChecked === true}
          />{" "}
          <label> Show On Menu</label>
        </>
      ),
      left: true,
      cell: (row) => (
        <>
          <input
            className="form-check-input"
            onChange={(e) => handleSwitchOnOff(e, row)}
            type="checkbox"
            role="switch"
            checked={row?.IsShowEcommerceMenu}
          />
        </>
      ),
    },
    // {
    //   name: "Action",
    //   width: "20%",
    //   cell: (row) => (
    //     <>
    //       {/* Edit Record Button  */}
    //       {checkUserPermission(PERMISSION_EDIT) ? (
    //         <Link
    //           className="me-3"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#ManageDataModal"
    //           data-backdrop="static"
    //           data-keyboard="false"
    //           onClick={() => handleUpdate(row.ID)}
    //         >
    //           <i class="fa fa-edit text-warning fa-2x" title="Edit"></i>
    //         </Link>
    //       ) : (
    //         ""
    //       )}

    //       {/** Delete Record Button */}
    //       {checkUserPermission(PERMISSION_DELETE) ? (
    //         <Link
    //           className="confirm-text"
    //           to="#"
    //           title="Delete"
    //           data-bs-toggle="modal"
    //           data-bs-target="#DeleteConfirmationModal"
    //           onClick={() => handleDeletePopup(row.ID)}
    //         >
    //           <i
    //             class="fa fa-trash text-red fa-2x"
    //             data-bs-toggle="tooltip"
    //             title="Delete"
    //           ></i>
    //         </Link>
    //       ) : (
    //         ""
    //       )}
    //     </>
    //   ),
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   button: true,
    // },
  ];
  
  const actionColumn = {
    name: "Action",
    width: "20%",
    cell: (row) => (
      <>
        <div className="btn-group-sm" role="group">
          {checkUserPermission(PERMISSION_EDIT) && (
            <Link
              className="btn btn-primary"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#ManageDataModal"
              data-backdrop="static"
              data-keyboard="false"
              onClick={() => handleUpdate(row.ID)}
            >
              Edit
            </Link>
          )}
          {checkUserPermission(PERMISSION_DELETE) && (
            <Link
              className="btn btn-sm btn-secondary confirm-text ml-2"
              to="#"
              title="Delete"
              data-bs-toggle="modal"
              data-bs-target="#DeleteConfirmationModal"
              onClick={() => handleDeletePopup(row.ID)}
            >
              Delete
            </Link>
          )}
        </div>
      </>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  };
  
  // const columns = [
  //   {
  //     name: "Action",
  //     width: "20%",
  //     cell: (row) => (
  //       <>
  //         <div class="btn-group-sm" role="group">
  //           {checkUserPermission(PERMISSION_EDIT) ? (
  //             <Link
  //               className="btn btn-primary"
  //               to="#"
  //               data-bs-toggle="modal"
  //               data-bs-target="#ManageDataModal"
  //               data-backdrop="static"
  //               data-keyboard="false"
  //               onClick={() => handleUpdate(row.ID)}
  //               // style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //             >
  //               Edit
  //             </Link>
  //           ) : (
  //             ""
  //           )}
  //           {checkUserPermission(PERMISSION_DELETE) ? (
  //             <Link
  //               className="btn btn-sm btn-secondary confirm-text ml-2"
  //               to="#"
  //               title="Delete"
  //               data-bs-toggle="modal"
  //               data-bs-target="#DeleteConfirmationModal"
  //               onClick={() => handleDeletePopup(row.ID)}
  //               // style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //             >
  //               {/* <i
  //               class="fa fa-trash "
  //               data-bs-toggle="tooltip"
  //               title="Delete"
  //             ></i> */}
  //               Delete
  //             </Link>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //     //width: "7%",//"100px",
  //     // minWidth: "100px",
  //     // width: "100px",
  //   },
  //   {
  //     name: "Categories",
  //     selector: "Name",
  //     width: "50%",
  //     sortable: true,
  //   },
  //   {
  //     name: "Image",
  //     selector: "ImageUrl",
  //     sortable: true,
  //     cell: (row) => (
  //       <>
  //         <Link to={row.Imagename} target="_blank">
  //           <img
  //             src={row.Imagename}
  //             alt="Selected Image"
  //             style={{
  //               // maxWidth: "30px",
  //               maxHeight: "50px",
  //               width: "30px",
  //               margin: "5px",
  //             }}
  //             onError={(e) => {
  //               e.target.onerror = null;
  //               e.target.src = Noimage;
  //             }}
  //           />
  //         </Link>
  //       </>
  //     ),
  //   },
  //   {
  //     name: (
  //       <>
  //         <input
  //           class="form-check-input mr-1"
  //           onChange={(event) => handelShowPopup(event.target.checked)}
  //           type="checkbox"
  //           role="switch"
  //           checked={valueAllChecked === true}
  //         />{" "}
  //         <label> Show On Menu</label>
  //       </>
  //     ),
  //     left: true,
  //     cell: (row) => (
  //       <>
  //         <input
  //           class="form-check-input"
  //           onChange={(e) => handleSwitchOnOff(e, row)}
  //           type="checkbox"
  //           role="switch"
  //           checked={row?.IsShowEcommerceMenu}
  //         />
  //       </>
  //     ),
  //   },
  //   // {
  //   //   name: "Action",
  //   //   width: "20%",
  //   //   cell: (row) => (
  //   //     <>
  //   //       {/* Edit Record Button  */}
  //   //       {checkUserPermission(PERMISSION_EDIT) ? (
  //   //         <Link
  //   //           className="me-3"
  //   //           to="#"
  //   //           data-bs-toggle="modal"
  //   //           data-bs-target="#ManageDataModal"
  //   //           data-backdrop="static"
  //   //           data-keyboard="false"
  //   //           onClick={() => handleUpdate(row.ID)}
  //   //         >
  //   //           <i class="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) : (
  //   //         ""
  //   //       )}

  //   //       {/** Delete Record Button */}
  //   //       {checkUserPermission(PERMISSION_DELETE) ? (
  //   //         <Link
  //   //           className="confirm-text"
  //   //           to="#"
  //   //           title="Delete"
  //   //           data-bs-toggle="modal"
  //   //           data-bs-target="#DeleteConfirmationModal"
  //   //           onClick={() => handleDeletePopup(row.ID)}
  //   //         >
  //   //           <i
  //   //             class="fa fa-trash text-red fa-2x"
  //   //             data-bs-toggle="tooltip"
  //   //             title="Delete"
  //   //           ></i>
  //   //         </Link>
  //   //       ) : (
  //   //         ""
  //   //       )}
  //   //     </>
  //   //   ),
  //   //   ignoreRowClick: true,
  //   //   allowOverflow: true,
  //   //   button: true,
  //   // },
  // ];
  const columns = [
    ...(checkUserPermission(PERMISSION_EDIT) || checkUserPermission(PERMISSION_DELETE) ? [actionColumn] : []),
    ...commonColumns,
  ];
  const checkFunction = (checkedBrands) => {
    let brandsList = {
      brandsList: checkedBrands.join(","),
      LoginUserId: loginUserId,
    };

    axios
      .post(
        `${config.brandBaseUrl}/brands/assignbrandecommercemenu`,
        brandsList,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          // toastSuccess(SUCCESS_MESSAGE)
          console.log("SetDone");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError(ERROR_EXISTS);
        } else {
          // toastError(ERROR_MESSAGE);
        }
      });
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, filtertext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPage, filtertext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPage, filtertext, e.id, sortingDirection);
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPage, e.target.value, sortingId, sortingDirection);
    console.log(handleListData);
  };

  const handleDateFilterConfirm = () => {
    setShowDateFilterModal(false);
    handleAllSwitchOnOff(valueAllChecked);
  };

  const handleAllSwitchOnOff = (checked) => {
    // const { checked } = e.target;
    console.log(checked, "checkedBy Allcategory");

    if (checked == true) {
      let finalArray = [];
      data.map((el) => finalArray.push(el?.ID));
      setCheckedBox(finalArray);

      const updatedData = data.map((el) => {
        return {
          ...el,
          IsShowEcommerceMenu: 1,
        };
      });
      setData(updatedData);
      checkFunction(finalArray);
    } else {
      setCheckedBox([]);
      const updatedData = data.map((el) => {
        return {
          ...el,
          IsShowEcommerceMenu: 0,
        };
      });
      setData(updatedData);
      checkFunction([]);
    }
  };

  const handleSwitchOnOff = (e, row) => {
    const { checked } = e.target;
    console.log(checked, row, "checkedBy Allcategory");

    if (checked === true) {
      console.log(checked, row?.ID, "checkedBy Allcategory");
      const FilterData = [...checkedBox, row?.ID];
      setCheckedBox(FilterData);

      const updatedData = data.map((el) => {
        if (el.ID === row?.ID) {
          return {
            ...el,
            IsShowEcommerceMenu: 1,
          };
        } else {
          return el;
        }
      });
      setData(updatedData);
      updatedData?.length === FilterData?.length
        ? setValueAllChecked(true)
        : setValueAllChecked(false);

      checkFunction(FilterData);
    } else {
      const FilterData = checkedBox.filter((item) => item !== row.ID);
      setCheckedBox(FilterData);

      const updatedData = data.map((el) => {
        if (el.ID === row?.ID) {
          return {
            ...el,
            IsShowEcommerceMenu: 0,
          };
        } else {
          return el;
        }
      });
      setData(updatedData);
      checkFunction(FilterData);

      updatedData?.length === FilterData?.length
        ? setValueAllChecked(true)
        : setValueAllChecked(false);
    }
  };

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
    setValueAllChecked(!valueAllChecked);
  };

  const _handleFileChange = (e) => {
    console.log(e, "imageUpload");

    const file = e.target.files[0];
    setSelectedImage(file);

    if (file) {
      // Display a preview of the selected image
      const reader = new FileReader();
      reader.onload = (event) => {
        setPreviewImage(event.target.result);
      };
      reader.readAsDataURL(file);
      // clearState(formValues)
      // formValues()
    }
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Inventory: Brand</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Manage Brands</li>
              </ul>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="col-md-4">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50"
                onChange={ChangeFilterText}
                value={searchtext}
              />
            </div>
            <div className="page-btn">
              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#ManageDataModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  // className="btn btn-added"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  onClick={() => handleManageDataPopup()}
                >
                  {/* <img src={PlusIcon} alt="img" className="me-1" /> */}
                  <i className="fa fa-plus me-2 lg"></i>
                  Add Brand
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* Data list */}
          {/* <div className="row">
            <div className="row flex-row-reverse">
              <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
                <input
                  type="search"
                  placeholder="Search..."
                  className="search-btn form-control form-control-sm w-50 pull-right"
                  onChange={ChangeFilterText}
                  value={searchtext}
                />
              </div>
            </div>
          </div> */}

          <div className="card">
            <div className="card-body" style={{ padding: "0px 20px 0 20px" }}>
              <div className="card-body pb-0">
                <div className="table-responsive">
                  <DataTable
                    // title="Category List"
                    columns={columns}
                    data={data}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    striped
                    responsive
                    paginationRowsPerPageOptions={[
                      10, 20, 30, 40, 50, 100, 200, 300, 400, 500,
                    ]}
                    persistTableHead
                    // onChangeRowsPerPage={(e) => {
                    //   handlePerRowsChange(1, e);
                    // }}
                    // perPage={10}
                    onChangePage={handlePageChange}
                    paginationPerPage={perPage}
                    dense
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Data list */}
        </div>
      </div>
      {/* Upset Model  */}
      <div
        className="modal fade"
        id="ManageDataModal"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="card-title">Manage Brands</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal(false)}
              >
                {" "}
                <span aria-hidden="true">×</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <Formik
                {...props}
                initialValues={formValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit2}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12">
                        <Field
                          type="hidden"
                          className="form-control"
                          id="ID"
                          name="ID"
                          value={values.ID}
                        />
                        <div className="form-group">
                          <label className="col-form-label p-lg-medium">
                            Brand Name
                          </label>
                          <Field
                            type="text"
                            name="Name"
                            className={` ${
                              errors.Name ? "is-invalid" : ""
                            } form-control form-control-sm`}
                            placeholder="Enter Brand Name"
                            value={values.Name}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <div className="invalid-feedback">
                            {touched.Name && errors.Name ? errors.Name : ""}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="col-form-label p-lg-medium">
                            Brand Image
                          </label>
                          <div className="col-md-9">
                            {/* File input */}
                            <input
                              type="file"
                              name="Imagename"
                              className={`form-control form-control-sm`}
                              onBlur={handleBlur}
                              onChange={(e) => _handleFileChange(e)}
                            />
                            {/* Display a preview of the selected image */}
                            {values.Imagename && (
                              <img
                                src={values.Imagename}
                                alt="Brand Image"
                                style={{ maxWidth: "100px" }}
                              />
                            )}
                          </div>
                          {previewImage && (
                            <div className="row mb-3">
                              <div className="col-md-3"></div>
                              <div className="col-md-9">
                                <img
                                  src={previewImage}
                                  alt="Category Image Preview"
                                  className="ImagePreviewSize"
                                />
                              </div>
                            </div>
                          )}

                          {/* <div className="invalid-feedback">{touched.Imagename && errors.Imagename ? errors.Imagename : ''}</div> */}
                        </div>
                      </div>

                      <div className="col-lg-12 justify-content-right">
                        <button
                          type="submit"
                          className="btn btn-primary btn-md me-1"
                          // onClick={handlesubmitdata(values.Name)}
                          // onSubmit={(e) => window.history.back()}
                          data-bs-dismiss="modal"
                        >
                          {" "}
                          Submit{" "}
                        </button>
                        <Link
                          to="#"
                          className="btn btn-dark btn-md me-1"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {/* Upset Model  */}
      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.brandBaseUrl}/brands/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />

      <div
        className={`modal ${showDateFilterModal ? "d-block" : ""} `}
        style={{ background: "rgba(0,0,0, 0.4)" }}
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ justifyContent: "center" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="card-title">Confirmation</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleDateFilterCancel}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6 className="col-form-label p-lg-medium">
                    Do you want to set at All ?
                  </h6>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleDateFilterConfirm()}
              >
                yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleDateFilterCancel}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Brand;
